export const WALLET_CONNECT_DIALOG_ID = 'wallet-connect-dialog';
export const BTC_WALLET_CONNECT_DIALOG_ID = 'btc-wallet-connect-dialog';

/**
 * Cache key for wallet connection. Used to select connection data from the store.
 */
export const CONNECTION_CACHE_KEY = 'wallet-connection';
export const SWITCH_CACHE_KEY = 'switch-network';

export const BTC_CONNECTION_CACHE_KEY = 'btc-connection';
